export default "__VITE_ASSET__CYFHFMwk__"